import type { ConstructedOngoingDownload } from '@mimir/client-common/model/ongoingDownload';
import type { PendingBatchImportFile } from '@mimir/web/premiere/interfaces';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import type { NotificationOps } from '@mimir/client-common/fileSync/notificationOps';
import type { Logger } from '@mimir/common/types/logger';
import type { LocalStateOps } from '@mimir/client-common/fileSync/localStateOps';
import { completeAndImport } from './completeAndImport';
import { executeBatchImportUsingSemaphore } from './executeBatchImportUsingSemaphore';

export async function importIntoNle(
  services: {
    applicationContext: AdobePanelContext | ElectronContext,
    notificationOps: NotificationOps,
    logger: Logger,
    localStateOps: LocalStateOps,
  },
  config: {
    downloadPath: string,
    userDataSystemPath: string,
    shouldUsePremierePreferences: boolean,
  },
  download: ConstructedOngoingDownload,
  localPath: string,
): Promise<void> {
  if (download.batchImportId) {
    const pendingFile: PendingBatchImportFile = download;
    pendingFile.importableLocalPath = localPath;
    await executeBatchImportUsingSemaphore(services, config, download.batchImportId);
  } else {
    await completeAndImport(services, config, download, localPath);
  }
}
